export default class DtoDataTypeStatistics {
	constructor(obj) {
		this.typeParameter = obj.sitetypeparameter
		this.nbSites = obj.nbsites
	}
}



// WEBPACK FOOTER //
// ./src/administration/dto/DtoDataTypeStatistics.js